import { render, staticRenderFns } from "./Wise_rentunit1.vue?vue&type=template&id=979d9d1a&scoped=true"
import script from "./Wise_rentunit1.vue?vue&type=script&lang=js"
export * from "./Wise_rentunit1.vue?vue&type=script&lang=js"
import style0 from "./Wise_rentunit1.vue?vue&type=style&index=0&id=979d9d1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979d9d1a",
  null
  
)

export default component.exports